import { Controller } from '@hotwired/stimulus';
import { templateContent } from '@/js/util';

export default class extends Controller {
  static values = { template: String };

  open(event) {
    event.preventDefault();

    const template = document.getElementById(this.templateValue);

    if (!template) {
      throw new Error(`render Contests::DesignerLoginCallout as #${this.templateValue}`);
    }

    document.body.append(templateContent(template));
  }
}
